module.exports = "<p>\n  youtube works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee/youtube/youtube.component.html
// module id = ./src/app/devotee/youtube/youtube.component.html
// module chunks = main